/*
  Lista de deseos de Stooner — sin apps ni cuenta de cliente.
  Los handles se guardan en localStorage; los datos de cada prenda se
  piden a /products/{handle}.js cuando hace falta pintarlos.
*/
(function () {
  'use strict';

  var KEY = 'stooner:wishlist';
  var ASKED_KEY = 'stooner:wishlist:asked';
  var cfg = window.StoonerWishlistConfig || {};
  var T = cfg.strings || {};
  var cache = {};

  /* ---------- estado ---------- */

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* modo privado o almacenamiento lleno: la sesión sigue funcionando */
    }
    paint();
    renderPage();
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    var added = i === -1;
    if (added) list.unshift(handle); else list.splice(i, 1);
    write(list);
    return added;
  }

  /* ---------- datos de producto ---------- */

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'products/' + handle + '.js'
      : '/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('404');
        return r.json();
      })
      .then(function (p) { cache[handle] = p; return p; });
  }

  function money(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return value + ' €';
  }

  /* ---------- pintado ---------- */

  function paint() {
    var list = read();

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? (T.remove || 'Quitar de la lista') : (T.add || 'Guardar en la lista'));
    });
  }

  /* ---------- panel ---------- */

  function panel() {
    return document.querySelector('[data-wishlist-panel]');
  }

  function open() {
    var p = panel();
    if (!p) return;
    p.classList.add('is-open');
    p.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wishlist-open');
    render();
  }

  function close() {
    var p = panel();
    if (!p) return;
    p.classList.remove('is-open');
    p.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wishlist-open');
  }

  function render() {
    var p = panel();
    if (!p) return;
    var body = p.querySelector('[data-wishlist-body]');
    var list = read();

    if (!list.length) {
      body.innerHTML = '<p class="wishlist__empty">' + (T.empty || 'Todavía no has guardado nada.') + '</p>';
      return;
    }

    body.innerHTML = '<p class="wishlist__loading">' + (T.loading || 'Cargando…') + '</p>';

    Promise.all(list.map(function (h) {
      return fetchProduct(h).catch(function () { return null; });
    })).then(function (products) {
      var html = products.map(function (prod, i) {
        if (!prod) return '';
        return itemHtml(prod, list[i]);
      }).join('');
      body.innerHTML = html || '<p class="wishlist__empty">' + (T.empty || 'Todavía no has guardado nada.') + '</p>';
    });
  }

  function itemHtml(p, handle) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var sizes = p.variants.map(function (v) {
      return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        (v.available ? v.title : v.title + ' · ' + (T.soldout || 'agotada')) + '</option>';
    }).join('');

    return '' +
      '<article class="wishlist-item" data-wishlist-item="' + handle + '">' +
        '<a class="wishlist-item__media" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="wishlist-item__info">' +
          '<a class="wishlist-item__title" href="' + p.url + '">' + p.title + '</a>' +
          '<div class="wishlist-item__price">' + money(p.price) + '</div>' +
          '<div class="wishlist-item__actions">' +
            '<select class="wishlist-item__size" aria-label="' + (T.size || 'Talla') + '">' + sizes + '</select>' +
            '<button type="button" class="wishlist-item__add" data-wishlist-add>' + (T.addToCart || 'Añadir') + '</button>' +
          '</div>' +
          '<button type="button" class="wishlist-item__remove" data-wishlist-remove="' + handle + '">' + (T.remove || 'Quitar') + '</button>' +
        '</div>' +
      '</article>';
  }

  /* ---------- página completa ---------- */

  function pageGrid() {
    return document.querySelector('[data-wishlist-page-grid]');
  }

  function renderPage() {
    var grid = pageGrid();
    if (!grid) return;
    var list = read();

    if (!list.length) {
      grid.innerHTML = '<p class="wishlist__empty">' + (T.empty || 'Todavía no has guardado nada.') + '</p>';
      return;
    }

    Promise.all(list.map(function (h) {
      return fetchProduct(h).catch(function () { return null; });
    })).then(function (products) {
      var html = products.map(function (prod, i) {
        return prod ? cardHtml(prod, list[i]) : '';
      }).join('');
      grid.innerHTML = html || '<p class="wishlist__empty">' + (T.empty || '') + '</p>';
    });
  }

  function cardHtml(p, handle) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var sizes = p.variants.map(function (v) {
      return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        (v.available ? v.title : v.title + ' · ' + (T.soldout || 'agotada')) + '</option>';
    }).join('');

    return '' +
      '<article class="wishlist-card" data-wishlist-item="' + handle + '">' +
        '<div class="wishlist-card__media">' +
          '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' + handle + '" aria-label="' + (T.remove || 'Quitar') + '">' +
            '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 3.8h12v16.4l-6-4.3-6 4.3z"/></svg>' +
          '</button>' +
        '</div>' +
        '<a class="wishlist-card__title" href="' + p.url + '">' + p.title + '</a>' +
        '<div class="wishlist-card__price">' + money(p.price) + '</div>' +
        '<select class="wishlist-card__size wishlist-item__size" aria-label="' + (T.size || 'Talla') + '">' + sizes + '</select>' +
        '<button type="button" class="wishlist-card__add wishlist-item__add" data-wishlist-add>' + (T.addToCart || 'Añadir al carrito') + '</button>' +
      '</article>';
  }

  /* ---------- carrito ---------- */

  function addToCart(itemEl) {
    var select = itemEl.querySelector('.wishlist-item__size, .wishlist-card__size');
    var btn = itemEl.querySelector('[data-wishlist-add]');
    if (!select || !select.value) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = T.adding || 'Añadiendo…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        btn.textContent = T.added || 'Añadido';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
      })
      .catch(function () {
        btn.textContent = T.error || 'No se pudo';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
      });
  }

  /* ---------- Klaviyo ---------- */

  function trackSaved(handle) {
    fetchProduct(handle).then(function (p) {
      if (!window.klaviyo || typeof window.klaviyo.push !== 'function') return;
      window.klaviyo.push(['track', 'Added to Wishlist', {
        Name: p.title,
        Handle: p.handle,
        URL: window.location.origin + p.url,
        ImageURL: p.featured_image || '',
        Price: p.price / 100
      }]);
    }).catch(function () { /* el seguimiento nunca debe romper la wishlist */ });
  }

  function subscribe(email) {
    if (!cfg.klaviyoCompanyId || !cfg.klaviyoListId) return Promise.reject();
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyoCompanyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Wishlist',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: cfg.klaviyoListId } } }
        }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo');
    });
  }

  /* ---------- franja de captura ---------- */

  function maybeAskEmail() {
    var p = panel();
    if (!p) return;
    var strip = p.querySelector('[data-wishlist-capture]');
    if (!strip) return;
    var asked = false;
    try { asked = localStorage.getItem(ASKED_KEY) === '1'; } catch (e) {}
    if (asked) return;
    strip.hidden = false;
  }

  function markAsked() {
    try { localStorage.setItem(ASKED_KEY, '1'); } catch (e) {}
  }

  /* ---------- eventos ---------- */

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      var handle = toggleBtn.getAttribute('data-handle');
      var added = toggle(handle);
      if (added) {
        trackSaved(handle);
        maybeAskEmail();
      }
      if (panel() && panel().classList.contains('is-open')) render();
      return;
    }

    var openEl = e.target.closest('[data-wishlist-open]');
    if (openEl) {
      var href = openEl.getAttribute('href');
      var isPageLink = href && href !== '#';
      /* si el enlace apunta a la página, se navega: misma experiencia
         en móvil y en ordenador. El cajón queda disponible por si se
         quiere recuperar. */
      if (isPageLink) return;
      e.preventDefault();
      open();
      return;
    }

    if (e.target.closest('[data-wishlist-close]') || e.target.hasAttribute('data-wishlist-overlay')) {
      close();
      return;
    }

    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      toggle(removeBtn.getAttribute('data-wishlist-remove'));
      render();
      return;
    }

    var addBtn = e.target.closest('[data-wishlist-add]');
    if (addBtn) {
      addToCart(addBtn.closest('[data-wishlist-item]'));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-wishlist-capture-form]');
    if (!form) return;
    e.preventDefault();

    var email = form.querySelector('input[type="email"]');
    var consent = form.querySelector('input[type="checkbox"]');
    var msg = form.parentNode.querySelector('[data-wishlist-capture-msg]');

    if (!email || !email.value || !consent || !consent.checked) {
      if (msg) msg.textContent = T.captureConsent || 'Marca la casilla para continuar.';
      return;
    }

    form.querySelector('button').disabled = true;
    subscribe(email.value)
      .then(function () {
        markAsked();
        if (msg) msg.textContent = T.captureOk || 'Listo, te avisaremos.';
        setTimeout(function () {
          var strip = form.closest('[data-wishlist-capture]');
          if (strip) strip.hidden = true;
        }, 1800);
      })
      .catch(function () {
        if (msg) msg.textContent = T.captureError || 'No se pudo guardar, inténtalo luego.';
        form.querySelector('button').disabled = false;
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  document.addEventListener('DOMContentLoaded', function () {
    paint();
    renderPage();
  });
  paint();

  window.StoonerWishlist = { read: read, has: has, toggle: toggle, open: open, close: close };
})();
